import { Link } from 'expo-router'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import { Icon } from '@/src/elements/media/Icon'
import { Typography } from '@/src/elements/text/Typography'
import { ICON } from '@/src/general/enums/icons'
import { useRoutes } from '@/src/general/utils/routes'

export const AuthPrivacyNotice = () => {
  const { routes } = useRoutes()

  return (
    <View className="items-center gap-2 px-3">
      <Icon name={ICON.LOCK} size="sm" className="text-default-text-contrast-low" />
      <Typography size="sm" contrast="low" center>
        <FormattedMessage
          id="auth.privacy.notice"
          values={{
            link: (chunks) => (
              <Link key="terms" href={routes.cgu()} className="text-primary-label-light underline">
                {chunks}
              </Link>
            ),
          }}
        />
      </Typography>
    </View>
  )
}
